import React from 'react';
import { useTranslation } from 'react-i18next';
import { BehaviourEntryType } from '@/types/overview';
import { tv } from '@/utils/tv';

const badge = tv({
  base: 'text-caption-12 inline-flex shrink-0 items-center rounded-2xl border border-transparent px-2 py-0.5 tracking-[0.025em] contrast:border-border',
  variants: {
    type: {
      [BehaviourEntryType.Positive]:
        'bg-success-surface text-successful dark:text-success',
      [BehaviourEntryType.Negative]: 'bg-warning-surface text-warning',
    },
  },
});

const sentimentLabelKey = {
  [BehaviourEntryType.Positive]: 'home.dashboard.diary.sentiment.positive',
  [BehaviourEntryType.Negative]: 'home.dashboard.diary.sentiment.negative',
} as const;

interface Props {
  type: BehaviourEntryType;
  className?: string;
}

export const SentimentBadge: React.FC<Props> = ({ type, className }) => {
  const { t } = useTranslation();

  return (
    <span className={badge({ type, className })}>
      {t(sentimentLabelKey[type])}
    </span>
  );
};
